import { render, staticRenderFns } from "./LightningBolt.vue?vue&type=template&id=0283591c"
import script from "./LightningBolt.vue?vue&type=script&lang=js"
export * from "./LightningBolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports